import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useFormContext } from 'react-hook-form';
import { IconButton, InputAdornment } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify/Iconify';

interface KeywordPortalProps {
  onSubmit?: () => void;
}

/**
 * 목록 화면에 Portal로 렌더링되는 키워드 검색 필드
 * SearchFilter가 닫혀있어도 항상 렌더링됨
 */
export const KeywordPortal: React.FC<KeywordPortalProps> = ({ onSubmit }) => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);
  const { watch, setValue } = useFormContext();
  const textValue = watch('text');

  // Portal 대상 요소가 DOM에 마운트될 때까지 기다림
  useEffect(() => {
    const checkPortalTarget = () => {
      const target = document.getElementById('keyword-search-portal');
      if (target) {
        setPortalTarget(target);
      } else {
        // 아직 DOM에 없으면 다음 틱에 다시 확인
        setTimeout(checkPortalTarget, 10);
      }
    };

    checkPortalTarget();
  }, []);

  if (!portalTarget) return null;

  return ReactDOM.createPortal(
    <RHFTextField
      name="text"
      label=""
      placeholder="키워드 검색(Enter)"
      size="small"
      sx={{ width: 250 }}
      onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && onSubmit) {
          e.preventDefault();
          onSubmit();
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify icon={'eva:search-fill'} />
          </InputAdornment>
        ),
        endAdornment: textValue && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => {
                setValue('text', '');
                onSubmit && onSubmit();
              }}
              edge="end"
            >
              <Iconify icon={'eva:close-fill'} width={18} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />,
    portalTarget,
  );
};
